<div class="text-center">

  <mat-icon>access_time</mat-icon>
  <h1 *ngIf="slot; else noSlotTitle" mat-dialog-title translate>dialog.slot.title.update</h1>

  <ng-template #noSlotTitle>
    <h1 mat-dialog-title translate>dialog.slot.title.create</h1>
  </ng-template>

  <div class="modal-body" mat-dialog-content>

    <div class="card container mt-3">
      
      <div class="row">
        
        <div class="col-sm">
          <span translate>dialog.slot.generic.time</span>
          <ngb-timepicker [(ngModel)] = "_time" [value] = "slot && slot.timeBegin"></ngb-timepicker>
        </div>

      </div>

      <div class="row">
        
        <custom-select  #visibilitySelect
                        title_multiple    = "dialog.slot.generic.visibility"
                        [values]          = "visibilities"
                        [selectFirstById] = "getSlotSameDayBook()"
                        (change)          = "visibilityChange($event)"
                        class             = "mx-3"
        ></custom-select>
        
      </div>

    </div>
  </div>

  <div class="modal-footer" mat-dialog-actions translate>

    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
      dialog.slot.generic.cancel
    </button>

    <button *ngIf="slot; else noSlotConfirm" type="button" class="btn btn-outline-secondary" (click)="update()" translate>
      dialog.slot.generic.confirm
    </button>

    <ng-template #noSlotConfirm>
      <button type="button" class="btn btn-outline-secondary" (click)="create()" translate>
        dialog.slot.generic.confirm
      </button>        
    </ng-template>

  </div>

</div>